module.exports = "/images/down-arrow.svg?8a2568b5b6154f8ac538ff115e7b8191";